import moment from 'moment/moment'

export function daysCount(
  minDate: Date,
  maxDate: Date,
) {
  const totalDays = moment(maxDate).diff(moment(minDate), 'days') + 1

  if (totalDays < 0) {
    return { durationHours: 0, durationDays: 0 }
  }

  const durationDays = totalDays
  const durationHours = durationDays * 24

  return { durationHours, durationDays }
}
